import {AfterViewChecked, AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewEncapsulation} from "@angular/core";
import {JwtHelperService} from "@auth0/angular-jwt";
import {BreakpointObserver, Breakpoints} from "@angular/cdk/layout";
import {MatDrawerMode} from "@angular/material/sidenav";

@Component({
    selector: 'app-dashboard-lo',
    templateUrl: './dashboard.layout.html',
    styleUrls: ['./dashboard.scss'],
    encapsulation: ViewEncapsulation.None
})

export class DashboardLayout implements OnInit, AfterViewChecked, AfterViewInit {
    public isExpanded: boolean;
    public isLogin: boolean;
    public mode: MatDrawerMode = 'side';
    public profile: any = {};
    constructor(
        private cdRef: ChangeDetectorRef,
        private breakpointObserver: BreakpointObserver,
        private jwtHelper: JwtHelperService,
    ) {
        this.isExpanded = true;
        this.isLogin = false;
    }
    ngAfterViewChecked(): void {
        this.cdRef.detectChanges();
    }

    ngAfterViewInit(): void {
        this.breakpointObserver
            .observe([Breakpoints.Handset])  // Watch for Handset (mobile)
            .subscribe((state) => {
                if (state.matches) {
                    this.mode = 'over';
                } else {
                    this.mode = 'side';
                }
            });
    }

    ngOnInit(): void {
        this.isLogin = !this.jwtHelper.isTokenExpired();
        if(this.isLogin) {
            this.profile = JSON.parse(localStorage.getItem('profile')) as any;
        }

    }

}
